import React, { useEffect, useId, useRef, useState } from "react";
import { FiCheck, FiHelpCircle, FiX } from "react-icons/fi";

export default function CourseSupportExplainer({ className = "course-explainer-trigger", label = "What is this?" }) {
  const [open, setOpen] = useState(false);
  const trigger = useRef(null);
  const closeButton = useRef(null);
  const titleId = useId();
  const introId = useId();

  useEffect(() => {
    if (!open) return undefined;
    closeButton.current?.focus();
    const closeOnEscape = event => {
      if (event.key === "Escape") {
        setOpen(false);
        window.requestAnimationFrame(() => trigger.current?.focus());
      }
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [open]);

  function close() {
    setOpen(false);
    window.requestAnimationFrame(() => trigger.current?.focus());
  }

  return <>
    <button ref={trigger} className={className} type="button" onClick={() => setOpen(true)} aria-haspopup="dialog" aria-expanded={open}>
      <FiHelpCircle aria-hidden="true" /> {label}
    </button>
    {open && <div className="course-explainer-backdrop" onMouseDown={event => { if (event.target === event.currentTarget) close(); }}>
      <section className="course-explainer" role="dialog" aria-modal="true" aria-labelledby={titleId} aria-describedby={introId}>
        <button ref={closeButton} className="course-explainer-close" type="button" onClick={close} aria-label="Close course support explanation"><FiX aria-hidden="true" /></button>
        <span className="course-explainer-icon"><FiHelpCircle aria-hidden="true" /></span>
        <h2 id={titleId}>Ongoing course, project and exam support</h2>
        <p id={introId}>This service is for customers who want a longer-term engagement with one writer - or help with a specific exam - all managed in one conversation.</p>
        <ul>
          <li><FiCheck aria-hidden="true" /><span><strong>An entire class or course:</strong> Coordinate assignments, discussions, projects and exams throughout the course.</span></li>
          <li><FiCheck aria-hidden="true" /><span><strong>A thesis, dissertation, capstone or long-term project:</strong> Continue with the same writer across chapters, milestones and revisions.</span></li>
          <li><FiCheck aria-hidden="true" /><span><strong>Exam assistance:</strong> Tell us whether your exam uses Respondus LockDown Browser or another platform, so support can confirm the available assistance and quote.</span></li>
          <li><FiCheck aria-hidden="true" /><span><strong>One place to communicate:</strong> Share instructions, upload files, ask related questions and receive work throughout the engagement. You can leave messages anytime.</span></li>
          <li><FiCheck aria-hidden="true" /><span><strong>Pay for agreed work:</strong> Discuss your needs first. Related clarification requires no separate order; additional paid work is quoted before it begins.</span></li>
        </ul>
        <p className="course-explainer-note"><strong>Start with a free quote.</strong> Explain your course, project or exam, and we’ll discuss the next steps.</p>
      </section>
    </div>}
  </>;
}
